module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.width > 770) ? _c('header', {
    staticClass: "c-header is-not-touch js-header u-fixed u-pos-tl u-zindex--50 u-viewport-fit-w",
    class: [_vm.small ? 'is-small' : '', _vm.isHidden ? 'is-hidden' : '']
  }, [_c('nav', {
    staticClass: "c-header__nav u-relative u-marg-x-auto u-flex u-flex-jc--space-between u-w10of12"
  }, [_c('div', {
    staticClass: "c-header__nav__logotype-container u-relative u-flex u-flex-ai--center"
  }, [_c('div', {
    staticClass: "u-relative u-block u-fit-w u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnLogotype()
      }
    }
  }, [_c('app-icon', {
    staticClass: "c-header__nav__logotype-container__svg",
    class: ['is-' + _vm.colorLogotype],
    attrs: {
      "name": "logotype"
    }
  })], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "c-header__nav__list-container js-nav-container"
  }, [_c('ul', {
    staticClass: "c-header__nav__list o-list--inline u-relative u-flex u-flex-jc--center u-flex-ai--center u-fit-h"
  }, _vm._l((_vm.$root.content.global.header.links), function(item, index) {
    return (item.isVisible) ? _c('li', {
      staticClass: "u-relative u-table u-fit-h",
      on: {
        "mouseenter": function($event) {
          _vm._onMouseenterItem(index)
        },
        "mouseleave": function($event) {
          _vm._onMouseleaveItem()
        }
      }
    }, [_c('router-link', {
      staticClass: "c-header__nav__list__item u-flex u-flex-fd--column u-flex-jc--center u-flex-ai--center t-ffamily--simplon u-uppercase t-fsize--xs",
      class: [_vm.$root.componentId === item.component ? 'is-hovered' : '', 'is-' + _vm.colorMenu, 'c-header__nav__list__item--' + index],
      attrs: {
        "to": _vm._getURLFromComponent(item.component),
        "index": index
      }
    }, [_c('div', {
      staticClass: "c-header__nav__list__item__line"
    }), _vm._v(" "), _c('div', {
      staticClass: "c-header__nav__list__item__text u-relative",
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })])], 1) : _vm._e()
  }))])]), _vm._v(" "), _c('span', {
    staticClass: "c-header__border u-absolute u-pos-bl u-fit-w",
    class: [_vm.borderVisible ? 'is-visible' : '']
  })]) : _c('header', {
    staticClass: "c-header is-touch u-fixed u-pos-tl u-zindex--50 u-fit-w",
    class: [_vm.$root.isMenuOpened ? 'is-open' : 'is-close']
  }, [_c('nav', {
    staticClass: "c-header__nav u-fixed u-pos-tl u-pad-x-w1of12 u-zindex--2 u-flex u-flex-jc--space-between u-flex-ai--center u-fit-w u-bg--black"
  }, [_c('div', {
    staticClass: "c-header__nav__logotype-container u-absolute"
  }, [_c('router-link', {
    staticClass: "u-relative u-block u-fit",
    attrs: {
      "to": _vm.CONFIG.pages.home.path
    }
  }, [_c('app-icon', {
    staticClass: "c-header__nav__logotype-container__svg u-fit u-fill--white u-stroke--white",
    attrs: {
      "name": "logotype"
    }
  })], 1)], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "c-header__nav__menu-trigger-container",
    on: {
      "click": function($event) {
        _vm.$root.isMenuOpened ? _vm._closeMenu() : _vm._openMenu()
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "c-header__menu-container u-absolute u-zindex--1 u-fit-w u-viewport-fit-h u-bg--black"
  }, [_c('ul', {
    staticClass: "c-header__menu-container__list o-list--none u-relative"
  }, _vm._l((_vm.$root.content.global.header.links), function(item, index) {
    return (item.isVisible) ? _c('li', {
      staticClass: "u-relative u-table u-fit-h"
    }, [_c('router-link', {
      staticClass: "c-header__menu-container__list__item u-table-cell u-valign-middle u-color--white",
      class: [_vm.$root.componentId === item.component ? 'is-active u-color--white' : 'u-color--white-o50', index === _vm.$root.content.global.header.links.length - 1 ? 'u-pad-l-xs' : 'u-pad-x-xs'],
      attrs: {
        "to": _vm._getURLFromComponent(item.component)
      },
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "c-header__menu-container__socials-container u-flex u-flex-ai--center u-bg--brand-primary"
  }, [_c('div', {
    staticClass: "u-relative u-force-3d u-zindex--6 u-marg-x-auto u-flex u-flex-ai--center u-w9of10"
  }, [_c('app-socials-links')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-relative u-fit u-flex u-flex-fd--column u-flex-jc--space-between"
  }, [_c('div', {
    staticClass: "c-header__nav__menu-trigger__bars c-header__nav__menu-trigger__bars--top u-fit-w u-bg--white"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__nav__menu-trigger__bars c-header__nav__menu-trigger__bars--bottom u-fit-w u-bg--white"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea145a44"}!./src/scripts/components/app-header/template.html
// module id = 486
// module chunks = 0